import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./Component/Layout";
import ScrollToTop from "./Component/ScrollToTop";

// Lazy-loaded pages
const Home = lazy(() => import("./Component/Home"));
const About = lazy(() => import("./Component/about"));
const Services = lazy(() => import("./Component/Services"));
const Products = lazy(() => import("./Component/Products"));
const Clients = lazy(() => import("./Component/Clients"));
const Contact = lazy(() => import("./Component/Contact"));
const Blog = lazy(() => import("./Component/blog"));
const Careers = lazy(() => import("./Component/Careers"));
const NotFound = lazy(() => import("./Component/NotFound"));

// Service Pages
const BillingSoftware = lazy(() => import("./Component/services/BillingSoftware"));
const WebDevelopment = lazy(() => import("./Component/services/WebDevelopment"));
const LocalSEOPage = lazy(() => import("./Component/services/LocalSEOPage"));
const ProductDetail = lazy(() => import("./Component/ProductDetail"));

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Layout>
        <Suspense fallback={<div className="flex items-center justify-center h-screen">Loading...</div>}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/billing-software" element={<BillingSoftware />} />
            <Route path="/services/web-development" element={<WebDevelopment />} />
            {/* Local SEO landing pages (Puducherry) */}
            <Route path="/software-company-puducherry" element={<LocalSEOPage />} />
            <Route path="/software-development-puducherry" element={<LocalSEOPage />} />
            <Route path="/website-development-puducherry" element={<LocalSEOPage />} />
            <Route path="/erp-software-puducherry" element={<LocalSEOPage />} />
            <Route path="/crm-software-puducherry" element={<LocalSEOPage />} />
            <Route path="/billing-software-puducherry" element={<LocalSEOPage />} />
            <Route path="/ai-company-puducherry" element={<LocalSEOPage />} />
            {/* Additional local SEO location pages */}
            <Route path="/software-company-villupuram" element={<LocalSEOPage />} />
            <Route path="/software-company-cuddalore" element={<LocalSEOPage />} />
            <Route path="/software-company-tamilnadu" element={<LocalSEOPage />} />
            <Route path="/software-company-india" element={<LocalSEOPage />} />
            {/* Industry-specific local SEO pages (Puducherry) */}
            <Route path="/textile-software-puducherry" element={<LocalSEOPage />} />
            <Route path="/restaurant-software-puducherry" element={<LocalSEOPage />} />
            <Route path="/hotel-management-software-puducherry" element={<LocalSEOPage />} />
            <Route path="/gym-management-software-puducherry" element={<LocalSEOPage />} />
            <Route path="/college-erp-puducherry" element={<LocalSEOPage />} />
            <Route path="/school-management-software-puducherry" element={<LocalSEOPage />} />
            <Route path="/grocery-store-software-puducherry" element={<LocalSEOPage />} />
            <Route path="/finance-accounting-software-puducherry" element={<LocalSEOPage />} />
            <Route path="/crm-small-business-puducherry" element={<LocalSEOPage />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/:productId" element={<ProductDetail />} />
            <Route path="/clients" element={<Clients />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
